module.exports = __webpack_public_path__ + "static/media/ios.6b4c4bc9.svg";